import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryCabin extends FDictionary {
  dictionary = 'cabin';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init().then();
    return item;
  }
}
